import ReactLoading from 'react-loading';
import {Grid, Typography} from 'material-ui';
import * as React from 'react';
import {connect} from 'react-redux';

class HeaderTopBar extends React.Component
{
    render() {
        return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid container justify="center">
                        <Grid item>
                            {this.props.showLoader &&
                                <span>
                                    <Typography
                                        variant="caption"
                                        style={{color: '#b5ccc6', marginBottom: -15 }}
                                        
                                    >Please wait...
                                    </Typography>
                                    <ReactLoading
                                        type="cylon"
                                        delay={0}
                                        color="#ffffff"
                                        width="64px"
                                        height="44px"
                                    />
                                </span>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = state => ({
    showLoader: state.layout.ajaxCallsInProgress > 0
});

export default connect(mapStateToProps, {})(
    HeaderTopBar
);


// WEBPACK FOOTER //
// ./src/containers/layout/header_bar.js